import "../../scss/index.scss";
import "./common-list.scss";
import "./menu/menu.js";
import "./application";
import "./header";

window.app.config([
  "$locationProvider",
  "$stateProvider",
  "$urlRouterProvider",
  function($locationProvider, $stateProvider, $urlRouterProvider) {
    var asyncState = function($stateProvider, name, defaultRedirect, ensure) {
      var url = "/" + name + "/async";
      var otherwiseTest = new RegExp("^/" + name + "(/.*)?$");
      var redirect;

      var config = {
        abstract: false,
        url: url,
        params: createApp({
          otherwise: true,
          otherwiseFn: [
            "$location",
            function($location) {
              var location = $location.path();
              if (otherwiseTest.test(location)) {
                redirect = window.location.hash.substr(1); // include querystring
                return url;
              }
            }
          ]
        }),
        template: "<ms-application></ms-application>",
        // template: '<h1>hello. will redir</h1>',

        // controllerProvider: ['module', function (module) {
        //   return ['$state', '$location', function ($state, $location) {
        //     setTimeout(function () {
        //       var url = window.location.href.replace(/#.*/g, '') + '#' + (redirect || defaultRedirect);
        //       window.location.replace(url);
        //       redirect = undefined;
        //     }, 1);
        //   }];
        // }],
        controller: function(module) {
          console.warn("Dummy controller here!", module);
        },
        resolve: {
          module: [
            "$ocLazyLoad",
            "$location",
            "$state",
            function($ocLazyLoad, $location) {
              console.log("on resolve");
              // debugger;

              ensure()
                .then(function() {
                  console.log("about to load " + name);
                  return $ocLazyLoad.load({
                    name: "ms" + name[0].toUpperCase() + name.slice(1)
                  });
                })
                .then(function() {
                  var url =
                    window.location.href.replace(/#.*/g, "") +
                    "#" +
                    (redirect || defaultRedirect);
                  console.log("loaded. will redirect to " + url);
                  setTimeout(() => {
                    window.location.replace(url);
                  }, 1);

                  // $location.replace();
                  // $location.url(redirect || defaultRedirect);
                  redirect = undefined;
                });
            }
          ]
        },
        animation: {
          enter: "fade-view-fast",
          leave: "fade-view-fast",
          navigate: "fade-view-fast",
          with: [name, `${name}.main`]
        }
      };
      $stateProvider.state(name + "-async", config);
      console.info("Configured state ", name + "-async");
    };

    const apps = require("./chunks");

    for (const name in apps) {
      asyncState($stateProvider, name, `/${name}`, apps[name]);
    }

    // asyncState($stateProvider, 'help', '/help', function () {
    //   return import(
    //     /* webpackChunkName: "help" */
    //     /* webpackMode: "lazy" */
    //     '../help/index.js'
    //   );
    // });

    function createApp($app) {
      var app = {};
      Object.defineProperty(app, "$app", {
        enumerable: true,
        value: $app
      });
      return app;
    }

    $stateProvider.state("placeholder", {
      abstract: false,
      url: "/placeholder",
      params: createApp({
        title: "Placeholder"
      }),
      template: "<ms-application></ms-application>"
    });

    console.warn("shared/index config ran");
  }
]);

// require('../timesheets');



// WEBPACK FOOTER //
// ./src/apps/shared/index.js